import axiosInstance from "pages/Utility/axiosInstance";

    /* ---------------- IMAGE UPLOAD ---------------- */
    export const uploadImage = async (setUploadingIndex,handleSliderChange,file, index) => {
        setUploadingIndex(index);

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = async () => {
            const res = await axiosInstance.post("V1/upload-base64", {
                image: reader.result,
                folder: "sliders"
            });

            handleSliderChange(index, "file", res.data.path);
            setUploadingIndex(null);
        };
    };

    export const uploadCollectionImage = async (setUploadingIndex,handleSliderChange,file, index) => {
        setUploadingIndex(index);

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = async () => {
            const res = await axiosInstance.post("V1/upload-base64", {
                image: reader.result,
                folder: "collections"
            });

            handleSliderChange(index, "file", res.data.path);
            setUploadingIndex(null);
        };
    };
